import {
	IconButton,
	makeStyles,
	MenuItem,
	Typography,
} from "@material-ui/core";
import React from "react";
import { FaChevronLeft } from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
	drawerHeader: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
		justifyContent: "flex-start",
	},
	button: {
		marginRight: theme.spacing(2),
	},
}));

const NavDrawerHeader = ({ siteTitle, handleClick }) => {
	const classes = useStyles();

	return (
		<div className={classes.drawerHeader}>
			<IconButton onClick={handleClick} className={classes.button}>
				<FaChevronLeft />
			</IconButton>
			<MenuItem href="/" component="a">
				<Typography variant="h6" >{siteTitle}</Typography>
			</MenuItem>
		</div>
	);
};

export default NavDrawerHeader;
